import { render, staticRenderFns } from "./archives-agreement.vue?vue&type=template&id=faa4bcd2&"
import script from "./archives-agreement.vue?vue&type=script&lang=js&"
export * from "./archives-agreement.vue?vue&type=script&lang=js&"
import style0 from "./archives-agreement.vue?vue&type=style&index=0&id=faa4bcd2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports